<template>
  <footer class="container p-4">
    <div class="bg-surface-container-low flex flex-col rounded-xl p-6">
      <slot></slot>
    </div>
  </footer>
</template>
